import React from 'react'
import { Link } from 'react-router-dom'
import { string } from 'prop-types'
import { useTranslation, Trans } from 'react-i18next'
import * as pageOptions from 'constants/pageOptions'

import RecoverAccountContainer from 'containers/accountAccess/RecoverAccountContainer'
import ResetPasswordContainer from 'containers/accountAccess/ResetPasswordContainer'
import SignupLoginContainer from 'containers/accountAccess/SignupLoginContainer'

require('./AccountAccessPage.scss')

const AccountAccessPage = ({ page }) => {
    const { t } = useTranslation()
    let content = null
    switch (page) {
        case pageOptions.RECOVER:
            content = <RecoverAccountContainer />
            break
        case pageOptions.RESET:
            content = <ResetPasswordContainer />
            break
        case pageOptions.LOGIN:
            content = <SignupLoginContainer isLogin />
            break
        case pageOptions.SIGNUP:
            content = <SignupLoginContainer />
            break
        default:
            content = t("we couldn't find the page you're looking for")
    }

    return (
        <div className="AccountAccessPage">
            <div className="accountAccessFormContainer">
                <div className="header">
                    <Link to="/">
                        <img src={`${ASSET_BUCKET}/logo_sugarcube_bug_ikea.svg`} alt={t('common.alt.logo')} />
                    </Link>
                </div>
                <div className="form">{content}</div>
            </div>
            <div className="promotionalImageContainer">
                <div className="textContainer">
                    <span>
                        <Trans t={t} i18nKey="account.try furniture">
                            Try furniture
                            <br />
                            in any room
                        </Trans>
                    </span>
                </div>
            </div>
        </div>
    )
}

AccountAccessPage.propTypes = {
    page: string.isRequired,
}

export default AccountAccessPage
